import { useState, useContext } from "react";
import getCurrentSkin from "../utils/getCurrentSkin";
import { ThemeContext } from "../context/ThemeContext";

import AdminTopbarMobile from "./TopbarMobile";
import AdminSidebar from "./AdminSidebar";

const AdminLayoutWrapper = ({ children }) => {
  const { isDark, skin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin); // ✅ safe always
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div
      className={`${
        isDark ? "bg-neutral-900 text-white" : "bg-gray-100 text-black"
      } flex min-h-screen relative`}
    >
      {/* Mobile Topbar */}
      <AdminTopbarMobile onOpenSidebar={() => setSidebarOpen(true)} />

      {/* Sidebar */}
      <AdminSidebar
        isMobileOpen={isSidebarOpen}
        onCloseMobile={() => setSidebarOpen(false)}
      />

      {/* Main Content */}
           <main className="flex-1 min-w-0 flex justify-center items-start sm:p-6 p-4 pt-20 sm:pt-6">
        <div
          className={`w-full min-w-0 max-w-[1400px] shadow-2xl min-h-screen p-6 sm:p-8 rounded-tr-[3rem] rounded-br-[3rem] ${
            isDark ? currentSkin.darkContent : currentSkin.content
          }`}
        >
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayoutWrapper;
